module.exports = __webpack_public_path__ + "img/search-1.0939698f.svg";